import styled from 'vue3-styled-components';

export const ProductGetDiv = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

export const ProductGetTitleArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-weight: bold;
    font-size: 20px;
`;

export const ProductGetSearchArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 30px;
`;

export const SearchLeftArea = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    position: absolute;
    left: 20px;
`;

export const SearchRightArea = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 400px;
`;

export const ProductGetSearchSelect = styled.select`
    height: 38px;
    padding: 0 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: white;
    font-size: 14px;
    min-width: 120px;

    &:focus {
        outline: none;
        border-color: #0066cc;
        box-shadow: 0 0 5px rgba(0, 102, 204, 0.1);
    }
`;

export const ProductGetSearchBtn = styled.button`
    background: #0f4c5c;
    height: 38px;
    padding: 0 10px;
    border: none;
    border-radius: 4px;
    color: white;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    gap: 5px;
    
    &:hover {
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(-2px);
    }
`;

export const ProductGetSearchInputTxt = styled.input`
    flex: 1;
    height: 38px;
    padding: 0 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;

    &:focus {
        outline: none;
        border-color: #0066cc;
        box-shadow: 0 0 5px rgba(0, 102, 204, 0.1);
    }

    &::placeholder {
        color: #999;
    }
`;

export const ProductGetBodyArea = styled.div`
    display: flex;
    width: 100%;
    height: calc(100% - 20px);
    position: relative;
    overflow: hidden;
`;

export const ProductGetHeaderArea = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - 420px);
    margin-left: auto;
    padding: 20px;
    position: relative;
`;

export const ProductGetBodyCategory = styled.div`
    position: absolute;
    left: 0;
    top: -12px;
    bottom: 0;
    width: 350px;
    padding: 5px 15px 5px 5px;
    background: white;
    z-index: 1;
    overflow-y: auto;

    // 기존 스크롤바 스타일 적용
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
        background: #ffc971;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #fb8b24;
    }
`;

export const ProductGetBodyTable = styled.table`
    flex: 1;
    margin-left: 400px;
    border-collapse: collapse;
    width: calc(100% - 320px);
    display: flex;
    flex-direction: column;
`;

export const ProductGetBodyProductInfo = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const ProductGetBodyProductInfoImg = styled.img`
    max-width: 80%;
    max-height: 80vh;
    min-width: 300px;
    min-height: 300px;
    object-fit: contain;
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const ProductGetBodyCategoryBuy = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 30px;
    
    > div:first-child {
        width: 100%;
        padding: 10px 0;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 2px solid #fb8b24;
        margin-bottom: 15px;
    }
`;

export const ProductGetBodyCategoryEtc = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: 30px;
    
    > div:first-child {
        width: 100%;
        padding: 10px 0;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 2px solid #fb8b24;
        margin-bottom: 15px;
    }
`;

export const ProductGetBodyCategoryBuyBtnArea = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
    
    > div {
        display: flex;
        flex-direction: row;
        gap: 8px;
        width: 100%;
        
        button {
            flex: 1;
            min-width: 0;
        }
    }
`;

export const ProductGetBodyCategoryEtcBtnArea = styled(ProductGetBodyCategoryBuyBtnArea)``;

export const ProductGetBodyCategoryBuyBtn = styled.button`
    padding: 8px 12px;
    text-align: center;
    background: white;
    border: 1px solid #fb8b24;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;

    &:hover {
        background: #ffeccc;
        border-color: #fb8b24;
    }

    &.active {
        background-color: #fb8b24;
        color: white;
    }
`;

export const ProductGetBodyCategoryRentBtn = styled(ProductGetBodyCategoryBuyBtn)``;

export const ProductGetBodyTableThead = styled.thead`
    display: block;
    width: 100%;
    background: #fb8b24;
    position: sticky;
    top: 0;
    z-index: 1;

    tr {
        display: flex;
        width: 100%;
        border: none;
        
        th {
            flex: 1;
            min-width: 80px;
            padding: 10px 5px;
            text-align: center;
            color: #000;
            font-size: 14px;
            border: none;
            
            &:nth-child(1) { width: 100px; flex: none; }  // 거래처
            &:nth-child(2) { width: 130px; flex: none; }  // 품목분류
            &:nth-child(3) { width: 150px; flex: none; }  // 바코드
            &:nth-child(4) { width: 130px; flex: none; }  // 제품명
            &:nth-child(5) { width: 40px; flex: none; }   // 사이즈
            &:nth-child(6) { width: 40px; flex: none; }   // 색상
            &:nth-child(7) { width: 50px; flex: none; }   // 위치
            &:nth-child(8) { width: 80px; flex: none; }   // 구입/대여
            &:nth-child(9) { width: 60px; flex: none; }   // 급여/비급여
            &:nth-child(10) { width: 120px; flex: none; }  // 출고단가
            &:nth-child(11) { width: 80px; flex: none; }  // 상세보기
        }
    }   
`;

export const ProductGetBodyTableTbody = styled.tbody`
    display: block;
    font-size: 13px;
    overflow-y: auto;
    height: calc(100vh - 250px);
    width: 100%;

    tr {
        display: flex;
        width: 100%;
        height: 40px;
        cursor: pointer;
        border-bottom: 1px solid #fb8b24;
        
        &:hover {
            background: #ffeccc;
            
            td {
                background: #ffeccc;
            }
        }
        
        td {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 5px;
            min-width: 80px;
            background: white;
            transition: background 0.2s ease;
            border: none;
            text-align: center;
            
            &:nth-child(1) { width: 100px; flex: none; }  // 거래처
            &:nth-child(2) { width: 130px; flex: none; }  // 품목분류
            &:nth-child(3) { 
                width: 150px; 
                flex: none; 
                overflow: hidden;
                text-overflow: ellipsis;
                position: relative;
            }  // 바코드/보험코드
            &:nth-child(4) { width: 130px; flex: none; }  // 제품명
            &:nth-child(5) { width: 40px; flex: none; }   // 사이즈
            &:nth-child(6) { width: 40px; flex: none; }   // 색상
            &:nth-child(7) { width: 50px; flex: none; }   // 위치
            &:nth-child(8) { width: 80px; flex: none; }   // 구입/대여
            &:nth-child(9) { width: 60px; flex: none; }   // 급여/비급여
            &:nth-child(10) { width: 120px; flex: none; }  // 출고단가
            &:nth-child(11) { width: 80px; flex: none; }  // 상세보기

            select {
                height: 28px;
                width: 90%;
                text-align: center;
                border: 1px solid #ccc;
                border-radius: 4px;
                background: white;
                font-size: 12px;
            }
        }
    } 

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
        background: #ffc971;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #fb8b24;
    }
`;

export const ProductGetBodyTableSelect = styled.select`
    height:30px;
`;

export const FontBold = styled.div`
    font-weight: bold;
    padding-top: 10px;
`;

export const HanqBtn = FontBold.extend`
    background: #ffffff;
    border: 1px solid #fb8b24;
    padding: 5px 10px;
    border-radius: 4px;
    cursor: pointer;
    width: 80%;
    display: flex;
    justify-content: center;
    font-size: 13px;
    color: #000;

    &:hover {
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(-2px);
    }
`;

export const ProductImageModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const ProductImageContainer = styled.div`
    position: relative;
    background: white;
    padding: 20px;
    border-radius: 8px;
`;

export const ProductImageTitle = styled.div`
    margin-bottom: 20px;
    font-weight: bold;
`;

export const ProductImageWrapper = styled.div`
    position: relative;
`;

export const ProductImage = styled.img`
    width: 300px;
    height: 300px;
    object-fit: contain;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 30px;
    cursor: pointer;

    &:hover {
        transform: translateY(-3px);
    }

    &:active {
        transform: translateY(-1px);
    }
`;

export const ProductModalContainer = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 1300px;
  width: 90%;
  max-height: 80vh;
  position: relative;
`;

export const TargetToggleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    width: fit-content;
    margin: 0 auto;
    height: 28px; // 높이 지정
`;

export const TargetButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s;
    padding: 0 8px;  // 좌우 패딩 추가
    height: 100%;    // 컨테이너 높이에 맞춤
    min-width: 40px; // 최소 너비 설정
    font-size: 13px; // 글자 크기 조정

    &.active {
        background-color: #0f4c5c;
        color: white;
    }

    &:hover:not(.active) {
        background-color: #0f4c5c;
        color: white;
    }
`;

export const TargetDivider = styled.span`
    color: #fb8b24;
    display: flex;
    align-items: center;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 1px;
        height: 25px;    // 구분선 높이
        background-color: #fb8b24;
    }
`;